import styled from "styled-components";
import { TextColorNames } from "@smartsuite/types";

export const StyledButton = styled.button<{
  isActive: boolean;
  fullWidth?: boolean;
}>`
  display: inline-flex;
  align-items: center;
  line-height: 18px;
  gap: 10px;
  cursor: pointer;
  margin-top: 8px;
  padding-left: 4px;
  padding-right: 8px;

  height: 24px;
  border-radius: 5px;
  background-color: transparent;

  /* Branch columns render a full-width card-style button (matches the root
     Add Action and the Figma branch design) rather than the inline link the
     Looping group uses. */
  ${({ fullWidth }) =>
    fullWidth === true &&
    `
    box-sizing: border-box;
    justify-content: center;
    width: 350px;
    height: 40px;
    margin-top: 10px;
    padding: 0;
    border-radius: 8px;
    /* transparent by default so the hover border doesn't shift layout */
    border: 1px solid transparent;
    background-color: rgba(255, 255, 255, 0.6);

    .small-add-action-button {
      color: #2e3538;
    }
  `}

  .small-add-action-button-icon {
    color: var(--solution-primary-color);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .small-add-action-button {
    color: ${TextColorNames.tertiary};

    &:hover {
      color: ${TextColorNames.primary};
    }
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    .small-add-action-button {
      color: ${TextColorNames.primary};
    }
  }
  ${(props) =>
    props.isActive &&
    `
    background-color: rgba(0,0,0,.05);
    .small-add-action-button {
      color: ${TextColorNames.primary};
    }
  `}

  /* Full-width (branch) variant mirrors the root Add Action hover: a primary
     border appears, background/text stay put (overrides the inline-link
     hover above). */
  ${({ fullWidth, isActive }) =>
    fullWidth === true &&
    `
    &:hover {
      background-color: rgba(255, 255, 255, 0.6);
      border-color: var(--solution-primary-color);
      .small-add-action-button {
        color: #2e3538;
      }
    }
    ${
      isActive
        ? `
      background-color: rgba(255, 255, 255, 0.6);
      border-color: var(--solution-primary-color);
      .small-add-action-button {
        color: #2e3538;
      }
    `
        : ""
    }
  `}
`;
